<template>
    <div>
        <CardBase class="shadow cursor-pointer"
                  @select="select">
            <div class="px-2 py-1 flex justify-between bg-white">
                <div class="flex">
                    <span class="text-xs bg-gray-200 rounded p-1 px-2">{{ $t('text.customerNumber') }}: {{ mission.customer_id }}</span>
                    <div class="pt-1 font-bold text-sm ml-2">{{ mission.location }}</div>
                </div>
            </div>
            <div class="bg-white">
                <div class="pl-2 pb-1">
                    <div><MissionProfileCompensation :compensation="mission.mission_profile.compensation"></MissionProfileCompensation></div>
                    <div><MissionProfileSummary :mission-profile="mission.mission_profile"></MissionProfileSummary></div>
                </div>
            </div>
            <div class="px-2 py-2 border-t bg-gray-200 flex justify-between"
                 :class="footerBackground">
                <div class="flex-col">
                    <span>
                        <svg version="1.2" class="inline" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24" width="18" height="18"><g><path xmlns:default="http://www.w3.org/2000/svg" d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" style="fill: rgb(94, 94, 94);" vector-effect="non-scaling-stroke"/></g></svg>
                    </span>
                    <span class="font-bold text-sm">{{ mission.arrival_date.split('-').reverse().join('.') }}</span>
                    <span class="ml-2 text-sm rounded bg-green-200 px-2">{{ mission.active_applications }} {{ $tc('component.mission.active_applications', mission.active_applications)}}</span>
                </div>
                <div>
                    <div v-if="application.status === 'applied'">
                        <GreenMailSVG class="inline"></GreenMailSVG> {{ $t('component.applicationItem.yourApplication')}}
                    </div>
                </div>
                <div>
                    <div v-if="application.status === 'applied'" class="rounded rounded-full bg-white px-2">
                        {{ $t('component.applicationItem.status.applied')}}
                    </div>
                    <div v-else-if="application.status === 'accepted'"><GreenSmileySVG class="inline"></GreenSmileySVG> {{ $t('component.applicationItem.status.accepted')}}</div>
                    <div v-else-if="application.status === 'denied'"><RedCrossSVG class="inline mb-1 mr-2"></RedCrossSVG> {{ $t('component.applicationItem.status.denied')}}</div>
                </div>
            </div>
        </CardBase>

        <div v-if="selected && application.status === 'applied'"
             class="mt-2 ml-2">
            <div class="ml-2 mr-2 mt-2" v-if="application.status === 'applied'">
                <div class="inline-block w-full bg-green-200 text-center px-4 py-2">
                    <p class="font-bold">{{ $t('component.applicationItem.applied.applicationActive') }}</p>
                    <p>{{ $t('component.applicationItem.applied.waitOnReaction') }}</p>
                </div>
            </div>
        </div>
        <div v-if="selected && application.status === 'accepted'">
            <div class="ml-2 mr-2 mt-4">
                <div class="border w-full border-green-600 p-2 bg-white inline-block text-center">
                    <div class="font-bold text-green-600">{{ $t('component.applicationItem.accepted.congrats')}}</div>
                    <div class="text-green-600">{{ $t('component.applicationItem.accepted.congrats2')}}</div>
                </div>
            </div>
            <CollapsibleCardBase>
                <template #title>
                    {{ $t('component.applicationItem.accepted.info.emergency.title')}}
                </template>
                <template #content>
                    <div class="w-full flex p-1">
                        <div class="w-1/3 text-right pr-2">
                            <div class="text-gray-800"></div>
                        </div>
                        <div class="w-2/3">
                            <div class="ml-1 mb-1">
                                <p class="underline mb-2">{{ $t('component.applicationItem.accepted.info.emergency.contact') }}</p>
                                <div><PhoneSVG></PhoneSVG> {{getPhoneNumber}}</div>
                            </div>
                        </div>
                    </div>
                </template>
            </CollapsibleCardBase>
        </div>
        <div v-if="selected && application.status === 'denied'"
             class="mt-2 ml-2">
            <div class="ml-2 mr-2 mt-4">
                <div class="inline-block w-full bg-red-200 text-center px-4 py-2">
                    <p class="font-bold">{{ $t('component.applicationItem.denied.text') }}</p>
                    <p>{{ $t('component.applicationItem.denied.text2') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    import CardBase from "@/components/shared/CardBase";

    import GreenMailSVG from "@/components/shared/svgs/GreenMailSVG";
    import GreenSmileySVG from "@/components/shared/svgs/GreenSmileySVG";
    import RedCrossSVG from "@/components/shared/svgs/RedCrossSVG";
    import CollapsibleCardBase from "@/components/shared/CollapsibleCardBase";
    import PhoneSVG from "@/components/shared/svgs/PhoneSVG";
    import MissionProfileCompensation from "@/components/missions/MissionProfileCompensation";
    import MissionProfileSummary from "@/components/missions/MissionProfileSummary";

    export default {
        name: "ApplicationItem",
        components: {
            MissionProfileSummary,
            MissionProfileCompensation,
            PhoneSVG, CollapsibleCardBase, RedCrossSVG, GreenSmileySVG, GreenMailSVG, CardBase },
        props: ['application', 'mission'],
        data() {
          return {
              selected: false,
          }
        },
        computed: {
            ...mapState('mission', {
                'lastAppliedMissionId': 'lastAppliedMissionId'
            }),
            ...mapState('auth', {
                'user': 'user'
            }),
            ...mapGetters('dlGroupConfig', [
                'getPhoneNumber',
            ]),
            footerBackground() {
                let bg = 'bg-gray-200';

                if (this.application.status === 'accepted')
                    bg = 'bg-green-200';

                return bg;
            }
        },
        created() {
            if (this.mission.mission_id === this.lastAppliedMissionId) {
                this.selected = true;
            }
        },
        methods: {
            select() {
                this.selected = !this.selected;
            }
        }
    }
</script>

<style scoped>

</style>